var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_20_37)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_20_37",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_20_37",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_20_37",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD0ElEQVR4nO3cTYhWVRzH8a9mGvnuYKQ4iEi+PctAcTW4iMJXLNsoZC58x0FdhKEEKuYyISUMdRMpvmDSooIo20SKiiCmKOlC1FTKl6iFOTOPHDwDOeRzznHm3nPnnN8HDsxCn/u/9zf3ufeee/4DIiIiIiIi4jIUaAGWAduB3cCXdpifPwaW2n8zxPlp8lwmAVuBk0AbUPccj4ATwGZgoo599/QF3gV+CQjANcxnvWM/WwLMBi72YBBdxwVgphJxGwUcKzCIruMo8KqC+X8zgJslhtE57gBvKpSnrQLaI4TROcyNwnKF8sSmiEHUu4yNuYeyrhsHrx24CvxorzvH7M9Xu3m2tZIpc0vbEXiwHgB77V3Y4AafbR4I5wD77P8JDfptMvMa8FfAQfoT+MARQqNwNgB3A7Z3HxhPJl4ATgUcnAPAyB7Y7ivAwYDtnrS1Jm9NwLTHigK2vzpg+mUliWuyXweuA/EvMK/AOubbbbjqMF9zw0nYZo+D0AEsKqGW9zzPko9I1EDPC+snJdb0qUc9fwAvkyCf38jLwEsl1jQAuORR10IS9L3Hjs+KUNc8j7q+IzGD7V1To50+E6m2PsBZR20PgUEkZJbHb+HSiPWt9KjvLRKyzbGzbZFvL5s8nk3MK+RkHHXsrHnvHdtpR42HSch5x87uil0g8JmjxnMk5JZjZ9fGLhBY76jxdxLyj2NnF8cuEHjfUePfJGSBff/xrNEcu0CePPw1CsTMfUmJWnP6yuoNtjgC+TV2gbn52hHIT7ELzElfj5noPbGLzG2RXt0xlsQuMidHPAIxCzOkpFYH10z0NTsrLCX4xuPsMK+epQSLPMIws8BjyygmdxM8F+uZJapSsGEeM9CdZ0et6GJy1x/4wSOMum0ilQK9CHzlGcZtu/xUCmLW6e73DKPDrp6XAsM44BlG3S6gkwLnqb4ICOO4vc5IAfrYC7NvGFd6qPVBnhHG5wFhXM+pSSdGGDsDwjB3VFNiF52yHYF96nr4i7icp/6fcQ94vchicjc3oCVaYRRsXEALtGmrm1p0QTnrB/zsGYYJbVrsglP3YUAY02MXm7rRdpln3WPl4Ruxi83BPs+zw/Q4SgkX8naPMEyrgVSgM6tu3wyW2dmb9Z3VDY9AzCI4KUGLRxjm7aBU6C/RtSiN8nzrCOM3hVGtvsXdCqTc17KPekHfYjZGeFw/9FReojG20b/RmFxmQSIiIiIiIiIiItI7NAOHHKMKf6UuGzWP6Xe1GCiQfNV0hlRLTYFUS02BVEtNgVRLTYFUS7OeQ0REREREROgRjwGrWNJyV8Fj9wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.1166e1c0efca39adc1a81955ecf1d4f2.svg";
export { ForwardRef as ReactComponent };